import { collection, doc, getDocs, onSnapshot } from "@firebase/firestore";
import { signInWithCustomToken, signOut } from "firebase/auth";
import { changeConversationList } from "stores/slices/conversation";
import { addMessage } from "stores/slices/message";
import { updateListNotification } from "stores/slices/notification";
import { setWorkspace } from "stores/slices/workspace";
import { setUserSetting } from "stores/slices/workspaceUser";

import { auth, db } from "./firebase";

export const listenFirestoreMessageEvent = (
  workspaceId,
  conversationId,
  dispatch
) => {
  auth.onAuthStateChanged(user => {
    if (user) {
      const unsubMessEvent = onSnapshot(
        collection(
          db,
          `workspaces/${workspaceId}/conversations/${conversationId}/events`
        ),
        doc => {
          if (doc.docChanges().length === 1) {
            doc.docChanges().map(change => {
              // console.log("doc.docChanges() mess", { ...change.doc.data() });
              const document = [
                {
                  id: change.doc.id,
                  ...change.doc.data(),
                  createdTime: change.doc.data().createdTime.seconds * 1000,
                  conversationId: conversationId,
                },
              ];

              return dispatch(addMessage(document[0]));
            });
          }
        },
        error => {
          console.log(error);
        }
      );
      return () => unsubMessEvent();
    }
  });
};

export const listenFirestoreConversationEvent = async (
  workspaceId,
  dispatch
) => {
  let docConversation = [];
  auth.onAuthStateChanged(user => {
    if (user) {
      const unsubscribe = onSnapshot(
        collection(db, `workspaces/${workspaceId}/conversations`),
        doc => {
          if (doc.docChanges().length === 1) {
            doc.docChanges().map(change => {
              console.log("doc.docChanges() con", { ...change.doc.data() });
              docConversation = [
                {
                  id: change.doc.id,
                  ...change.doc.data(),
                  sendTime: change.doc.data().sendTime?.seconds * 1000,
                  createdTime: change.doc.data().createdTime?.seconds * 1000,
                  lockTime: change.doc.data().lockTime?.seconds * 1000,
                  updatedTime: change.doc.data().updatedTime?.seconds * 1000,
                },
              ];
              if (
                docConversation[0].lastMessage === "" &&
                docConversation[0].lastMessageDataType === "MEDIA" &&
                docConversation[0].totalMediaContent > 0
              ) {
                let newConversation;
                let newLastMessage;
                switch (docConversation[0].lastMessageMediaContentType) {
                  case "IMAGE":
                    newLastMessage = `Send ${
                      docConversation[0].totalMediaContent > 1
                        ? docConversation[0].totalMediaContent + " photos"
                        : "a photo"
                    }`;
                    break;
                  case "FILE":
                    newLastMessage = `Send ${
                      docConversation[0].totalMediaContent > 1
                        ? docConversation[0].totalMediaContent + " files"
                        : "a file"
                    }`;
                    break;
                  case "VIDEO":
                    newLastMessage = `Send ${
                      docConversation[0].totalMediaContent > 1
                        ? docConversation[0].totalMediaContent + " videos"
                        : "a video"
                    }`;
                    break;
                  case "AUDIO":
                    newLastMessage = `Send ${
                      docConversation[0].totalMediaContent > 1
                        ? docConversation[0].totalMediaContent + " audio"
                        : "a audio"
                    }`;
                    break;
                  default:
                    break;
                }
                newConversation = {
                  ...docConversation[0],
                  lastMessage: newLastMessage,
                };
                return dispatch(changeConversationList(newConversation));
              }
              return dispatch(changeConversationList(docConversation[0]));
            });
          }
        },
        error => {
          console.log(error);
        }
      );
      return () => unsubscribe();
    }
  });
};

export const listenFirestoreWorkspaceEvent = (workspaceId, dispatch) => {
  let workspace = null;
  auth.onAuthStateChanged(user => {
    if (user) {
      // console.log("workspaceId", workspaceId);
      const unsubscribe = onSnapshot(
        doc(db, `workspaces`, workspaceId),
        doc => {
          // console.log("doc work", { ...doc.data() });
          if (
            doc.data()?.properties !== undefined &&
            doc.data()?.settings !== undefined
          ) {
            workspace = {
              properties: {
                ...doc.data()?.properties,
                id: doc.id,
                createdTime: doc.data().properties?.createdTime?.seconds * 1000,
              },
              settings: {
                ...doc.data()?.settings,
              },
            };
          }
          // console.log("workspace", { ...doc.data() });
          return dispatch(setWorkspace(workspace));
        },
        error => {
          console.log(error);
        }
      );
      return () => unsubscribe();
    }
  });
};

export const listenFirestoreUserSettingEvent = (
  userId,
  workspaceId,
  dispatch
) => {
  let userSetting = null;
  auth.onAuthStateChanged(user => {
    if (user) {
      const unsubscribe = onSnapshot(
        doc(db, `users/${userId}/workspaces/${workspaceId}`),
        doc => {
          userSetting = {
            ...doc.data(),
            createdTime:
              doc.data()?.createdTime?.seconds !== undefined
                ? doc.data().createdTime?.seconds * 1000
                : "",
          };
          console.log("userSetting", userSetting);
          return dispatch(setUserSetting(userSetting));
        },
        error => {
          console.log(error);
        }
      );
      return () => unsubscribe();
    }
  });
};

export const getFirestoreMediaContent = async (
  workspaceId,
  conversationId,
  messageId
) => {
  // How to set timeout when listen media contents
  try {
    let mediaContents = [];
    const querySnapshot = await getDocs(
      collection(
        db,
        `workspaces/${workspaceId}/conversations/${conversationId}/events/${messageId}/mediaContents`
      )
    );
    querySnapshot.forEach(doc => {
      const data = doc.data();
      mediaContents = [
        ...mediaContents,
        { ...data, createdTime: data.createdTime?.seconds * 1000 },
      ];
    });
    return mediaContents;
  } catch (error) {
    console.log(error);
  }
};

export const getFirestoreNote = async (
  workspaceId,
  conversationId,
  messageId
) => {
  try {
    let notes = [];
    const querySnapshot = await getDocs(
      collection(
        db,
        `workspaces/${workspaceId}/conversations/${conversationId}/events/${messageId}/notes`
      )
    );
    querySnapshot.forEach(doc => {
      const data = doc.data();
      notes = [
        ...notes,
        { ...data, createdTime: data.createdTime?.seconds * 1000 },
      ];
    });

    notes.sort(function (a, b) {
      return new Date(b.createdTime) - new Date(a.createdTime);
    });
    return notes;
  } catch (error) {
    console.log("error", error);
  }
};

export const getNewNotifications = async (userId, dispatch) => {
  let isFirstFetch = true;
  let notifications = [];
  auth.onAuthStateChanged(user => {
    if (user) {
      const unsubscribe = onSnapshot(
        collection(db, `users/${userId}/notifications`),
        doc => {
          if (isFirstFetch) {
            isFirstFetch = false;
            return;
          } else {
            doc.docChanges().map(change => {
              notifications = [
                {
                  ...change.doc.data(),
                  sentTime: change.doc.data().sentTime?.seconds * 1000,
                  id: parseInt(change.doc.id),
                },
              ];
              return dispatch(updateListNotification(notifications));
            });
          }
        },
        error => {
          console.log(error);
        }
      );

      return () => unsubscribe;
    }
  });
};

export const requestSignInWithCustomToken = (auth, fsToken) => {
  signInWithCustomToken(auth, fsToken)
    .then(userCredential => {
      // Signed in
      const user = userCredential.user;
      user
        .getIdTokenResult()
        .then(idTokenResult => {
          // Confirm the user is an Admin.
          console.log("idTokenResult", idTokenResult);
          return idTokenResult;
        })
        .catch(error => {
          console.log(error);
        });
    })
    .catch(error => {
      console.log(error);
    });
};

export const requestSignOut = auth => {
  signOut(auth)
    .then(() => {
      // Sign-out successful.
      console.log("Sign-out successful");
    })
    .catch(error => {
      // An error happened.
      console.log(error);
    });
};
